import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8d2bd71a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "picklist-detail" }
const _hoisted_2 = { class: "picklist-detail-status" }
const _hoisted_3 = { class: "mx-3 py-3" }
const _hoisted_4 = { class: "mx-3" }
const _hoisted_5 = {
  key: 0,
  class: "picklist-detail-tour-info px-3 py-3"
}
const _hoisted_6 = { class: "position-header" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "flex-fill" }

import {ref, computed, watch, getCurrentInstance, nextTick, onUnmounted} from 'vue';
import PositionItem from '@/components/Picklist/PositionItem.vue';
import PicklistProgress from '@/components/Picklist/PicklistProgress.vue';
import {doAlert, doConfirm, groupBy, sleep} from '@/util';
import ArticleSearch from '../ArticleSearch.vue';
import router from '@/router';
import {InvalidInputError, ModifyByScanOptions, UserAbortError, usePicklistPickerStore} from '@/store/picklistPickerV2';
import {parseBarcode} from 'gs1-barcode-parser-mod';
import {NativeAudio} from '@capgo/native-audio';
import moment from 'moment';
import Picklist, {ApiPicklistState, ApiPicklistType} from '@/model/Picklist';
import {useScanner} from '@/store/scanner';
import {getShelf} from '@/api/module/warehouse';
import useWarehousesStore from '@/store/warehouses';
import useSubsidiariesStore from '@/store/subsidiaries';
import {searchNVE} from '@/api/module/nve';


export default /*#__PURE__*/_defineComponent({
  __name: 'PicklistDetail',
  props: {
  data: {
    type: Picklist,
    required: true,
  },
},
  setup(__props, { expose: __expose }) {

const props = __props;

const instance = getCurrentInstance();
const articleSearch = ref<{ doSearch(force: boolean): Promise<number> } | null>(null);
const showAddDialog = ref(false);
const articleSearchSWord = ref('');
const searchEan = ref('');
const scanner = useScanner();
articleSearch.value?.doSearch(true);

const positionItemRefs = ref<any[]>([]);

watch(showAddDialog, (newVal, oldVal) => {
  if (!newVal && oldVal) articleSearchSWord.value = '';
});

const picklistPicker = usePicklistPickerStore();

const handleArticleSelect = () => {
  articleSearchSWord.value = '';
  showAddDialog.value = false;

  picklistPicker.eventEmitter.dispatchEvent(new Event('select'));
};

const parkPicklist = async () => {
  try {
    await sleep(100);
    await picklistPicker.park();
    const route = instance?.proxy?.$route?.matched[0];
    if (route) router.push(route).catch(console.error);
  } catch (err: any) {
    await doAlert(err.message, 'Fehler');
  }
};

const submitPicklist = async () => {
  try {
    await sleep(100);
    const performedActionName = picklistPicker.picklist?.isIncoming || picklistPicker.picklist?.isOutgoing ? 'buchen' : 'speichern';
    if (!(await doConfirm(`Möchten Sie den Beleg wirklich ${performedActionName}?`, `Wirklich ${performedActionName}?`, {
      ok: 'Ja',
      cancel: 'Nein',
    }))) {
      return;
    }
    await picklistPicker.submit();
    const route = instance?.proxy?.$route?.matched[0];
    if (route) router.push(route).catch(console.error);
  } catch (err: any) {
    console.error(err);
    await doAlert(err.message, 'Fehler');
  }
};

async function doSearch(data: ModifyByScanOptions) {
  showAddDialog.value = true;
  await nextTick();
  const resultCount = await articleSearch.value?.doSearch(true);
  if (resultCount === 1) {
    await nextTick();
    await picklistPicker.modifyByScan(data);
  } else if (resultCount === 0) {
    showAddDialog.value = false;
    throw new Error('Nicht gefunden');
  }
}

let picking = false;
const pickGs1 = async (gs1Code: string): Promise<ModifyByScanOptions> => {
  // Daten aus GS1-Code sammeln
  const decodedGS1 = parseBarcode(gs1Code);
  let nve = undefined as string | undefined;
  let ean = undefined as string | undefined;
  let batchNo = undefined as number | undefined;
  let shelf = undefined as number | undefined;
  let addQty = undefined as number | undefined;
  let manufacturingDate = undefined as string | undefined;
  let bestBeforeDate = undefined as string | undefined;
  let dealerBatchNo = undefined as string | undefined;
  let warehouse = undefined as number | undefined;
  let subsidiary = undefined as number | undefined;
  for (const part of decodedGS1.parsedCodeItems) {
    switch (part.ai) {
      case '00':
        if (part.raw.length != 18) throw new Error('Ungültige NVE');
        nve = part.raw;
        break;
      case '01':
      case '02':
        const code = (part.raw as string);
        if ((code).startsWith('0')) {
          ean = code.substring(1);
        } else {
          ean = code;
        }
        break;
      case '10':
      case '23':
        if (props.data.isIncoming) {
          dealerBatchNo = part.raw;
        } else {
          batchNo = Number(part.raw);
        }
        break;
      case '11':
        manufacturingDate = moment(part.data as Date).format('YYYY-MM-DD');
        break;
      case '12':
      case '15':
      case '17':
        bestBeforeDate = moment(part.data as Date).format('YYYY-MM-DD');
        break;
      case '37':
        addQty = addQty ? addQty * parseFloat(part.data as string) : parseFloat(part.data as string); // Gebindemenge
        break;
      case '91':
        if (part.raw.length > 10) throw new Error('Ungültiger Scan');
        shelf = Number(part.raw);

        const foundShelf = await getShelf(shelf);
        if (!foundShelf) break;

        warehouse = foundShelf.Lagerhalle;
        subsidiary = foundShelf.Niederlassung;

        break;
      case '30':
      case '37':
      case '3100':
      case '3101':
      case '3102':
      case '3103':
      case '3104':
      case '3105':
      case '3106':
      case '3107':
      case '3300':
      case '3301':
      case '3302':
      case '3303':
      case '3304':
      case '3305':
        addQty = parseFloat(part.data as string);
        break;
    }
  }

  const data: ModifyByScanOptions = {
    ean,
    addQty,
    nve,
    batchNo,
    dealerBatchNo,
    shelf,
    warehouse,
    subsidiary,
    bestBeforeDate,
    manufacturingDate,
  };

  console.log('data', JSON.stringify(data));

  // Standardmenge auf 1 für EAN
  if (!data.nve && data.ean) data.addQty = data.addQty ?? 1;

  return data;
};

const pickEan = (ean: string): ModifyByScanOptions => {
  return {
    ean,
    addQty: 1,
  };
};
const pick = async (barcode: string, type: 'ean' | 'gs1') => {
  try {
    if (picking) return;
    picking = true;

    const data = type === 'gs1' ? await pickGs1(barcode) : pickEan(barcode);

    // EAN / Artikelnummer aus Suche übergeben
    try {
      if (props.data?.isIncoming && picklistPicker.selectedPosition !== null && !data.ean) {
        data.insertInCurrentPositionIfNotFound = true;
      }

      if (props.data?.isIncoming) {
        // click Teilbuchung hinzufügen through parent if current qty is > 0
        if (picklistPicker.selectedPosition !== null && positionItemRefs.value[picklistPicker.selectedPosition]) {
          const positionItemRef = positionItemRefs.value[picklistPicker.selectedPosition];
          const currentBooking = positionItemRef.bookings[positionItemRef.bookings.length - 1];

          if (currentBooking.nve === null && data.nve) {
            await picklistPicker.modifyByScan(data);
          } else if (currentBooking.nve && data.nve && !(currentBooking.qty > 0)) {
            if (await doConfirm('Die Position ist unvollständig.\nSoll die NVE trotzdem übernommen werden?', 'Fehler')) {
              await picklistPicker.modifyByScan(data);
            }
          } else if (currentBooking.nve && data.nve && currentBooking.qty > 0) {
            await positionItemRef.addBooking();
            await picklistPicker.modifyByScan(data);
          } else if (!currentBooking.nve && data.nve && currentBooking.qty > 0) {
            await picklistPicker.modifyByScan(data);
            await positionItemRef.addBooking();
          } else {
            await picklistPicker.modifyByScan(data);
          }
        } else {
          await picklistPicker.modifyByScan(data);
        }
      } else {
        await picklistPicker.modifyByScan(data);
      }
    } catch (e: any) {
      console.log(e);
      if (e instanceof InvalidInputError) throw e; // Fehlerhafte Eingabe => nicht suchen

      // Abgebrochen beim Scannen (z.B. durch MHD Meldung)
      if (e instanceof UserAbortError) {
        picking = false;
        return;
      }

      // Nicht gefunden, an die Artikelsuche übergeben
      if (!props.data?.isIncoming || data.ean) {
        if (data.nve && await searchForNVE(data.nve)) { // vorher noch die api fragen, ob die nve wirklich nicht existiert
          await nextTick();
          await picklistPicker.modifyByScan(data);
          picking = false;
          return;
        }

        if (props.data.isOutgoing && props.data?.Picklistnr !== '-1') throw e; // Pickliste => keine Suche möglich

        articleSearchSWord.value = data.ean ?? data.nve ?? '';
        await doSearch(data);
        picking = false;
        return;
      } else if (props.data?.isIncoming) {
        throw e;
      }
    }

    // Aktustische Rückmeldung
    if (data.nve) {
      NativeAudio.play({
        assetId: 'nve-positive',
        time: 0.00,
      });
    } else {
      console.log('tone action positive');
      NativeAudio.play({
        assetId: 'action-positive',
        time: 0.00,
      });
    }
  } catch (err: any) {
    console.log('tone negative');
    NativeAudio.play({
      assetId: 'action-negative',
      time: 0.00,
    });

    await doAlert(err.message ?? err, 'Fehler');
  }
  picking = false;
};

const searchForNVE = async (nve: string) => {
  const response = await searchNVE(nve);
  console.log('found NVE', response);
  if (response != null) {
    for (const position of picklistPicker.picklist!.allPositions) {
      if (position.Artikelnr === response.ArtikelNr) {
        position.VerfuegbareNVEsCache![response.NVE] = {
          Chargennr: response.Chargennr,
          Datum: response.Datum,
          NVE: response.NVE,
          Restmenge: response.Restmenge,
          Niederlassung: response.Niederlassung,
          Lagerhalle: response.Lagerhalle,
          Lagerfach: response.Lagerfach,
        };
        return true;
      }
    }
  }
  return false;
};

const groupedAuftraege = computed(() => {
  const data = groupBy(props.data.allPositions ?? [], 'NameBelegnr');

  if (props.data.mayAddPosition && Object.values(data).length <= 0) {
    return {
      [`${props.data.lieferantName}-0`]: [],
    };
  }

  return data;
});

const submit = async () => {
  try {
    pick(searchEan.value, searchEan.value.length === 13 ? 'ean' : 'gs1');
  } catch (err: any) {
    await doAlert(err.message, 'Fehler');
  }
};

let scanning = false;
const updateResultHandler = (isReadonly: boolean) => {
  if (!isReadonly) {
    scanner.addScanListener(async (event) => {
      if (scanning) return;
      scanning = true;
      try {
        const isGs1 = event.type && (
          event.scannerType === 'seuic' ? [
            'Code128',
            'ISBT128',
            'QR',
            'GS1-128',
            'DataMatrix',
            'GS1-Databar',
            'Databar',
            'RSS14',
            'RSS Expanded',
          ].includes(event.type) : [
            'LABEL-TYPE-CODE128',
            'LABELTYPE-CODE128',
            'LABEL-TYPE-EAN128',
            'LABELTYPE-EAN-128',
            'LABEL-TYPE-QRCODE',
            'LABEL-TYPE-GS1-QRCODE',
            'LABEL-TYPE-DATAMATRIX',
            'LABEL-TYPE-GS1-DATAMATRIX',
            'LABEL-TYPE-GS1-DATABAR',
            'LABEL-TYPE-GS1-DATABAR-LIM',
            'LABEL-TYPE-GS1-DATABAR-EXP',
          ].includes(event.type)
        );
        await pick(event.data, isGs1 ? 'gs1' : 'ean');
      } finally {
        scanning = false;
      }
    }).catch(console.error);
  } else {
    scanner.removeScanListener().catch(console.error);
  }
};

watch(computed(() => picklistPicker.readonly), (isReadonly, isReadonlyOld) => {
  if (isReadonlyOld === isReadonly) return;
  updateResultHandler(isReadonly);
});

updateResultHandler(picklistPicker.readonly);

const warehouseStore = useWarehousesStore();
warehouseStore.fetch();
const subsidiariesStore = useSubsidiariesStore();
subsidiariesStore.fetch();

onUnmounted(() => scanner.removeScanListener().catch(console.error));

async function deletePosition(index: string) {
  await picklistPicker.deletePosition(index);
}

__expose({
  showAddDialog,
  parkPicklist,
  submitPicklist,
  submit,
  pick,
  deletePosition,
  groupedAuftraege,
  picklistPicker,
  articleSearchSWord,
  ApiPicklistType,
  articleSearch,
  handleArticleSelect,
  searchEan,
  ApiPicklistState,
  PositionItem,
  PicklistProgress,
  ArticleSearch,
  props,
});

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_fade_transition = _resolveComponent("v-fade-transition")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_slide_y_transition = _resolveComponent("v-slide-y-transition")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_footer = _resolveComponent("v-footer")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_overlay, {
      modelValue: _unref(picklistPicker).loading,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(picklistPicker).loading) = $event)),
      class: "align-center justify-center",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_progress_circular, { indeterminate: "" })
              ], undefined, true),
              _: 1
            })
          ], undefined, true),
          _: 1
        })
      ], undefined, true),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", null, [
      _createVNode(_component_v_text_field, {
        modelValue: searchEan.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchEan).value = $event)),
        label: "Scan EAN",
        variant: "filled",
        onKeypress: _withKeys(submit, ["enter"]),
        disabled: _unref(picklistPicker).readonly,
        "hide-details": ""
      }, {
        "append-inner": _withCtx(() => [
          _createVNode(_component_v_fade_transition, null, {
            default: _withCtx(() => [
              (__props.data.allPositions)
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 0,
                    onClick: submit
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-barcode-scan")
                    ], undefined, true),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], undefined, true),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_layout, { class: "align-center" }, {
        default: _withCtx(() => [
          _createElementVNode("strong", _hoisted_3, " Verbleibend: " + _toDisplayString(_unref(picklistPicker).remainingItems), 1),
          _createVNode(_component_v_divider, { vertical: "" }),
          _createElementVNode("span", _hoisted_4, " Abgeschlossen: " + _toDisplayString(_unref(picklistPicker).completedItems), 1),
          _createVNode(_component_v_spacer),
          (_unref(picklistPicker).completionPercentage < 100)
            ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                key: 0,
                "model-value": _unref(picklistPicker).completionPercentage,
                class: "mr-2"
              }, null, 8, ["model-value"]))
            : (_openBlock(), _createBlock(_component_v_icon, {
                key: 1,
                color: "success",
                class: "mr-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" mdi-checkbox-marked-circle-outline ")
                ], undefined, true),
                _: 1
              }))
        ], undefined, true),
        _: 1
      }),
      _createVNode(_component_v_divider)
    ]),
    _createElementVNode("div", null, [
      (__props.data.showProgress)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(PicklistProgress, { picklist: __props.data }, null, 8, ["picklist"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_v_slide_y_transition, { class: "py-0" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedAuftraege.value, (auftraege, createdBy) => {
            return (_openBlock(), _createBlock(_component_v_card, {
              key: createdBy,
              variant: "elevated",
              rounded: "0",
              class: "my-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_subtitle, { class: "py-2 bg-grey-lighten-3" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("b", null, _toDisplayString(__props.data.isUmbuchung ? 'An ' + __props.data.NiederlassungEingehend?.Name1 : auftraege[0]?.Name ?? __props.data.lieferantName), 1),
                      _hoisted_7,
                      (auftraege[0]?.Belegnr && __props.data.showBelegnr)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(__props.data.isIncoming ? 'Bestellung' : 'Auftrag') + ": " + _toDisplayString(auftraege[0].Belegnr), 1))
                        : _createCommentVNode("", true)
                    ])
                  ], undefined, true),
                  _: 2
                }, 1024),
                _createVNode(_component_v_list, {
                  opened: _unref(picklistPicker).selectedPosition !== null ? [_unref(picklistPicker).selectedPosition] : [],
                  "onUpdate:opened": _cache[2] || (_cache[2] = ($event: any) => (_unref(picklistPicker).selectedPosition = $event[0] ?? null))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(auftraege, (position, i) => {
                      return (_openBlock(), _createBlock(PositionItem, {
                        key: position.uniqueIndex,
                        ref_for: true,
                        ref: el => positionItemRefs.value[i] = el,
                        value: i,
                        expanded: _unref(picklistPicker).selectedPosition === i,
                        onDeletePosition: ($event: any) => (deletePosition(position.uniqueIndex)),
                        "position-index": i,
                        picklist: __props.data,
                        deletable: __props.data.mayAddPosition && !(position.givenByApi && !__props.data.isInventory && !__props.data.isSuggestion && !__props.data.isCorrection)
                      }, null, 8, ["value", "expanded", "onDeletePosition", "position-index", "picklist", "deletable"]))
                    }), 128))
                  ], undefined, true),
                  _: 2
                }, 1032, ["opened"]),
                (auftraege.length <= 0 && __props.data.mayAddPosition)
                  ? (_openBlock(), _createBlock(_component_v_alert, {
                      key: 0,
                      class: "mb-0 text-center"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Es ist keine Position vorhanden. Klicken Sie unten rechts auf "),
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-plus")
                          ], undefined, true),
                          _: 1
                        }),
                        _createTextVNode(" , um eine hinzuzufügen ")
                      ], undefined, true),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], undefined, true),
              _: 2
            }, 1024))
          }), 128))
        ], undefined, true),
        _: 1
      })
    ]),
    _createVNode(_component_v_app_bar, {
      location: "bottom",
      height: "auto"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          (_unref(picklistPicker).editError)
            ? (_openBlock(), _createBlock(_component_v_toolbar, {
                key: 0,
                color: "error",
                height: "auto",
                class: "text-white"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createElementVNode("small", null, _toDisplayString(_unref(picklistPicker).editError.message), 1),
                  _createVNode(_component_v_spacer)
                ], undefined, true),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!__props.data.isIncoming)
            ? (_openBlock(), _createBlock(_component_v_toolbar, {
                key: 1,
                class: "text-white",
                color: __props.data.StatusColor,
                height: 22
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createElementVNode("small", null, [
                    (__props.data.StatusIcon)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          start: "",
                          size: "small",
                          color: "white"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-" + _toDisplayString(__props.data.StatusIcon), 1)
                          ], undefined, true),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(__props.data.StatusName), 1)
                  ]),
                  _createVNode(_component_v_spacer)
                ], undefined, true),
                _: 1
              }, 8, ["color"]))
            : _createCommentVNode("", true),
          (!_unref(picklistPicker).readonly)
            ? (_openBlock(), _createBlock(_component_v_footer, {
                key: 2,
                class: "pa-0",
                elevation: 0
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_card_actions, null, {
                    default: _withCtx(() => [
                      (__props.data.isOutgoing && __props.data.Picklistnr !== '-1')
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            onClick: parkPicklist,
                            color: "primary",
                            variant: "outlined",
                            loading: _unref(picklistPicker).parking,
                            size: "x-large"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Parken ")
                            ], undefined, true),
                            _: 1
                          }, 8, ["loading"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_btn, {
                        onClick: submitPicklist,
                        class: _normalizeClass(`${_unref(picklistPicker).valid ? 'pl-9 pr-8' : 'pl-6 pr-6'} btn-navigator-primary`),
                        loading: _unref(picklistPicker).submitting,
                        size: "x-large"
                      }, {
                        append: _withCtx(() => [
                          (!_unref(picklistPicker).valid)
                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                key: 0,
                                class: "ml-0",
                                size: "large"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("mdi-alert")
                                ], undefined, true),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.data.saveBtnText) + " ", 1)
                        ], undefined, true),
                        _: 1
                      }, 8, ["class", "loading"])
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_v_spacer),
                  (__props.data.mayAddPosition ?? false)
                    ? (_openBlock(), _createBlock(_component_v_dialog, {
                        key: 0,
                        modelValue: showAddDialog.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showAddDialog).value = $event)),
                        "max-width": "600"
                      }, {
                        activator: _withCtx(({props}) => [
                          _createVNode(_component_v_btn, _mergeProps(props, {
                            icon: "",
                            class: "btn-navigator-primary",
                            size: "large"
                          }), {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(" mdi-plus ")
                                ], undefined, true),
                                _: 1
                              })
                            ], undefined, true),
                            _: 2
                          }, 1040)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(ArticleSearch, {
                            onSelect: handleArticleSelect,
                            modelValue: articleSearchSWord.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((articleSearchSWord).value = $event)),
                            ref_key: "articleSearch",
                            ref: articleSearch
                          }, null, 8, ["modelValue"])
                        ], undefined, true),
                        _: 1
                      }, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ], undefined, true),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ], undefined, true),
      _: 1
    })
  ]))
}
}

})